module.exports = __webpack_public_path__ + "tempal-icons.353ac2e17f6928b9278c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/tempal-icons/tempal-icons.woff?c8otwj
// module id = 485
// module chunks = 5